import gql from 'graphql-tag';
import { graphql } from '@apollo/react-hoc';
import FairsAvailability from './fairs-availability';
import { SimpleLoadingComponent } from '../../utils/apollo';

const query = gql`
  query FairsAvailability($id: String!, $fromDate: OrdinalDate) {
    viewer {
      id
      institution {
        id
        field_he_control
      }
    }
    highSchoolBySchoolId(id: $id) {
      id
      name
      general {
        field_hs_na_nces_id
      }
      naviance {
        field_hs_na_nguid
        field_hs_elna_phone
      }
      address {
        field_hs_elna_address_line1
        field_hs_elna_city
        field_hs_elna_state_latest
        field_hs_eln_zip
      }
      repVisitsAccount {
        id
        schoolTimezone
        allowForProfit
        collegeFairsPrimaryContact {
          id
          mail
          field_first_name
          field_last_name
        }
      }
      collegeFairs(first: 100, fromDate: $fromDate) {
        edges {
          node {
            id
            timezone
            name,
            date,
            startTime,
            endTime,
            rsvpDeadline,
            hasRsvpDeadlinePassed,
            maxColleges,
            currentColleges,
            numberOfExpectedStudents,
            cost,
            notes,
            webInstructions,
            emailInstructions,
            autoConfirmRequests,
            status
            attending
          }
        }
      }
    }
  }
`;

const graphqlData = graphql(query, {
  options: ({ id, fromDate }) => ({
    variables: {
      id,
      fromDate,
    },
    fetchPolicy: 'cache-and-network',
  }),
});

export default SimpleLoadingComponent(graphqlData)(FairsAvailability);
